import React from 'react';
import { Card, makeStyles, useMediaQuery } from '@material-ui/core';
import RegisterFormStep from './RegisterFormStep/RegisterFormStep';

const useCardStyles = (isMobileView) =>
  makeStyles({
    root: {
      marginTop: isMobileView ? 0 : 40,
      padding: isMobileView ? `24px 20px 60px 20px` : `40px 60px`,
    },
  });

const RegisterForm = (props) => {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  const classes = useCardStyles(isMobileView)();

  return (
    <Card className={classes.root}>
      <RegisterFormStep {...props} />
    </Card>
  );
};

export default RegisterForm;
